/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as AdminDefs from '../../../com/atproto/admin/defs.defs'
import * as RepoStrongRef from '../../../com/atproto/repo/strongRef.defs'

const $nsid = 'tools.ozone.inbox.defs'

type $nsid = typeof $nsid

export { $nsid }

/** Reference to a report by its report table ID, as used by getReport and Ozone's report detail page. */
type ReportRef = {
  $type?: 'tools.ozone.inbox.defs#reportRef'
  status?: 'pending' | 'resolved' | l.UnknownString
  subject?:
    | l.$Typed<AdminDefs.RepoRef>
    | l.$Typed<RepoStrongRef.Main>
    | l.Unknown$TypedObject
  reportId: number
}

export type { ReportRef }

/** Reference to a report by its report table ID, as used by getReport and Ozone's report detail page. */
const reportRef = /*#__PURE__*/ l.typedObject<ReportRef>(
  $nsid,
  'reportRef',
  /*#__PURE__*/ l.object({
    status: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{ knownValues: ['pending', 'resolved'] }>(),
    ),
    subject: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.typedUnion(
        [
          /*#__PURE__*/ l.typedRef<AdminDefs.RepoRef>(
            (() => AdminDefs.repoRef) as any,
          ),
          /*#__PURE__*/ l.typedRef<RepoStrongRef.Main>(
            (() => RepoStrongRef.main) as any,
          ),
        ],
        false,
      ),
    ),
    reportId: /*#__PURE__*/ l.integer(),
  }),
)

export { reportRef }

/** A single moderation action taken against a subject. */
type ActionView = {
  $type?: 'tools.ozone.inbox.defs#actionView'

  /**
   * Action ID (moderation event ID).
   */
  id: number

  /**
   * Public action type.
   */
  type: string
  scope?: 'network' | 'app' | 'labelOnly' | l.UnknownString

  /**
   * Label values, for labelApplied/labelRemoved.
   */
  labels?: string[]

  /**
   * Policies applied by a takedown action.
   */
  policies?: PolicyView[]
  createdAt: l.DatetimeString
  expiresAt?: l.DatetimeString
  reversedAt?: l.DatetimeString
}

export type { ActionView }

/** A single moderation action taken against a subject. */
const actionView = /*#__PURE__*/ l.typedObject<ActionView>(
  $nsid,
  'actionView',
  /*#__PURE__*/ l.object({
    id: /*#__PURE__*/ l.integer(),
    type: /*#__PURE__*/ l.string(),
    scope: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{
        knownValues: ['network', 'app', 'labelOnly']
      }>(),
    ),
    labels: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(/*#__PURE__*/ l.string()),
    ),
    policies: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<PolicyView>((() => policyView) as any),
      ),
    ),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    expiresAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    reversedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
  }),
)

export { actionView }

/** The state of the viewer's appeal against the actions on a subject. */
type AppealView = {
  $type?: 'tools.ozone.inbox.defs#appealView'
  state:
    'none' | 'pending' | 'resolved' | 'superseded' | 'expired' | l.UnknownString

  /**
   * Decision on a resolved appeal.
   */
  outcome?: 'approved' | 'denied' | l.UnknownString
  appealedAt?: l.DatetimeString

  /**
   * When the appeal's report was closed.
   */
  resolvedAt?: l.DatetimeString
  appealableUntil?: l.DatetimeString
}

export type { AppealView }

/** The state of the viewer's appeal against the actions on a subject. */
const appealView = /*#__PURE__*/ l.typedObject<AppealView>(
  $nsid,
  'appealView',
  /*#__PURE__*/ l.object({
    state: /*#__PURE__*/ l.string<{
      knownValues: ['none', 'pending', 'resolved', 'superseded', 'expired']
    }>(),
    outcome: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{ knownValues: ['approved', 'denied'] }>(),
    ),
    appealedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    resolvedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    appealableUntil: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
  }),
)

export { appealView }

type PolicyView = {
  $type?: 'tools.ozone.inbox.defs#policyView'
  key: string
  link: l.UriString
  displayName: string
}

export type { PolicyView }

const policyView = /*#__PURE__*/ l.typedObject<PolicyView>(
  $nsid,
  'policyView',
  /*#__PURE__*/ l.object({
    key: /*#__PURE__*/ l.string(),
    link: /*#__PURE__*/ l.string({ format: 'uri' }),
    displayName: /*#__PURE__*/ l.string(),
  }),
)

export { policyView }

type SubjectRef = {
  $type?: 'tools.ozone.inbox.defs#subjectRef'
  subject:
    | l.$Typed<AdminDefs.RepoRef>
    | l.$Typed<RepoStrongRef.Main>
    | l.Unknown$TypedObject
  actionId?: number
  actionType?: string

  /**
   * Decision captured when an appealResolved notification was created. Omitted when the outcome is unknown.
   */
  appealOutcome?: 'approved' | 'denied' | l.UnknownString
}

export type { SubjectRef }

const subjectRef = /*#__PURE__*/ l.typedObject<SubjectRef>(
  $nsid,
  'subjectRef',
  /*#__PURE__*/ l.object({
    subject: /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<AdminDefs.RepoRef>(
          (() => AdminDefs.repoRef) as any,
        ),
        /*#__PURE__*/ l.typedRef<RepoStrongRef.Main>(
          (() => RepoStrongRef.main) as any,
        ),
      ],
      false,
    ),
    actionId: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    actionType: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    appealOutcome: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{ knownValues: ['approved', 'denied'] }>(),
    ),
  }),
)

export { subjectRef }

type StandingRef = {
  $type?: 'tools.ozone.inbox.defs#standingRef'
  standing: 'good' | 'warning' | 'atRisk' | l.UnknownString
  previousStanding?: 'good' | 'warning' | 'atRisk' | l.UnknownString
}

export type { StandingRef }

const standingRef = /*#__PURE__*/ l.typedObject<StandingRef>(
  $nsid,
  'standingRef',
  /*#__PURE__*/ l.object({
    standing: /*#__PURE__*/ l.string<{
      knownValues: ['good', 'warning', 'atRisk']
    }>(),
    previousStanding: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{ knownValues: ['good', 'warning', 'atRisk'] }>(),
    ),
  }),
)

export { standingRef }

/** A subject belonging to the viewer that has moderation actions against it. */
type SubjectView = {
  $type?: 'tools.ozone.inbox.defs#subjectView'

  /**
   * DID of the moderation service that took the actions.
   */
  src: l.DidString
  appeal?: AppealView
  isRead: boolean
  subject:
    | l.$Typed<AdminDefs.RepoRef>
    | l.$Typed<RepoStrongRef.Main>
    | l.Unknown$TypedObject
  createdAt: l.DatetimeString
  updatedAt: l.DatetimeString
  actionCount?: number
  enforcement: EnforcementView
  latestAction?: ActionView
  availableActions?: ('appeal' | l.UnknownString)[]
}

export type { SubjectView }

/** A subject belonging to the viewer that has moderation actions against it. */
const subjectView = /*#__PURE__*/ l.typedObject<SubjectView>(
  $nsid,
  'subjectView',
  /*#__PURE__*/ l.object({
    src: /*#__PURE__*/ l.string({ format: 'did' }),
    appeal: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<AppealView>((() => appealView) as any),
    ),
    isRead: /*#__PURE__*/ l.boolean(),
    subject: /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<AdminDefs.RepoRef>(
          (() => AdminDefs.repoRef) as any,
        ),
        /*#__PURE__*/ l.typedRef<RepoStrongRef.Main>(
          (() => RepoStrongRef.main) as any,
        ),
      ],
      false,
    ),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    updatedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    actionCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    enforcement: /*#__PURE__*/ l.ref<EnforcementView>(
      (() => enforcementView) as any,
    ),
    latestAction: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<ActionView>((() => actionView) as any),
    ),
    availableActions: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.string<{ knownValues: ['appeal'] }>(),
      ),
    ),
  }),
)

export { subjectView }

type Notification = {
  $type?: 'tools.ozone.inbox.defs#notification'
  id: number
  isRead: boolean
  reason:
    | 'reportResolved'
    | 'reportReopened'
    | 'actionTaken'
    | 'actionReversed'
    | 'appealResolved'
    | 'standingChanged'
    | l.UnknownString
  target:
    | l.$Typed<ReportRef>
    | l.$Typed<SubjectRef>
    | l.$Typed<StandingRef>
    | l.Unknown$TypedObject
  createdAt: l.DatetimeString
}

export type { Notification }

const notification = /*#__PURE__*/ l.typedObject<Notification>(
  $nsid,
  'notification',
  /*#__PURE__*/ l.object({
    id: /*#__PURE__*/ l.integer(),
    isRead: /*#__PURE__*/ l.boolean(),
    reason: /*#__PURE__*/ l.string<{
      knownValues: [
        'reportResolved',
        'reportReopened',
        'actionTaken',
        'actionReversed',
        'appealResolved',
        'standingChanged',
      ]
    }>(),
    target: /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<ReportRef>((() => reportRef) as any),
        /*#__PURE__*/ l.typedRef<SubjectRef>((() => subjectRef) as any),
        /*#__PURE__*/ l.typedRef<StandingRef>((() => standingRef) as any),
      ],
      false,
    ),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
  }),
)

export { notification }

/** Aggregate view of reports filed against this subject. Deliberately carries no report IDs, no count, and no reporter identities. */
type ReportsSummary = {
  $type?: 'tools.ozone.inbox.defs#reportsSummary'

  /**
   * Distinct reason types reported, deduplicated and unordered. Excludes reasonAppeal.
   */
  reasonTypes: string[]

  /**
   * Day of the most recent report, truncated to midnight UTC. Render as a date; the time component is not meaningful.
   */
  lastReportedOn: l.DatetimeString

  /**
   * Day of the earliest report, truncated to midnight UTC. Render as a date; the time component is not meaningful.
   */
  firstReportedOn: l.DatetimeString
}

export type { ReportsSummary }

/** Aggregate view of reports filed against this subject. Deliberately carries no report IDs, no count, and no reporter identities. */
const reportsSummary = /*#__PURE__*/ l.typedObject<ReportsSummary>(
  $nsid,
  'reportsSummary',
  /*#__PURE__*/ l.object({
    reasonTypes: /*#__PURE__*/ l.array(/*#__PURE__*/ l.string()),
    lastReportedOn: /*#__PURE__*/ l.string({ format: 'datetime' }),
    firstReportedOn: /*#__PURE__*/ l.string({ format: 'datetime' }),
  }),
)

export { reportsSummary }

/** The current enforcement state of a subject. */
type EnforcementView = {
  $type?: 'tools.ozone.inbox.defs#enforcementView'
  scope?: 'network' | 'app' | 'labelOnly' | l.UnknownString
  state:
    'none' | 'labeled' | 'removed' | 'suspended' | 'takendown' | l.UnknownString

  /**
   * Active label values on the subject, excluding negated and expired labels.
   */
  labels?: string[]
  expiresAt?: l.DatetimeString
}

export type { EnforcementView }

/** The current enforcement state of a subject. */
const enforcementView = /*#__PURE__*/ l.typedObject<EnforcementView>(
  $nsid,
  'enforcementView',
  /*#__PURE__*/ l.object({
    scope: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{
        knownValues: ['network', 'app', 'labelOnly']
      }>(),
    ),
    state: /*#__PURE__*/ l.string<{
      knownValues: ['none', 'labeled', 'removed', 'suspended', 'takendown']
    }>(),
    labels: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(/*#__PURE__*/ l.string()),
    ),
    expiresAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
  }),
)

export { enforcementView }

/** A subject with a page of its action history and an aggregate report summary. Follow cursor to retrieve older actions; enforcement and appeal describe the current subject state on every page. */
type SubjectViewDetail = {
  $type?: 'tools.ozone.inbox.defs#subjectViewDetail'
  src: l.DidString
  appeal?: AppealView

  /**
   * Cursor for the next page of action history. Omitted when no older actions remain.
   */
  cursor?: string
  isRead: boolean

  /**
   * Raw record JSON for the subject, when the subject is a record and the record is available.
   */
  record?: l.LexMap

  /**
   * A page of action history, most recent first. Reversal timestamps include changes outside this page.
   */
  actions: ActionView[]

  /**
   * Omitted when the subject has never been reported, e.g. proactive enforcement.
   */
  reports?: ReportsSummary
  subject:
    | l.$Typed<AdminDefs.RepoRef>
    | l.$Typed<RepoStrongRef.Main>
    | l.Unknown$TypedObject
  createdAt: l.DatetimeString
  updatedAt: l.DatetimeString
  enforcement: EnforcementView
  availableActions?: ('appeal' | l.UnknownString)[]
}

export type { SubjectViewDetail }

/** A subject with a page of its action history and an aggregate report summary. Follow cursor to retrieve older actions; enforcement and appeal describe the current subject state on every page. */
const subjectViewDetail = /*#__PURE__*/ l.typedObject<SubjectViewDetail>(
  $nsid,
  'subjectViewDetail',
  /*#__PURE__*/ l.object({
    src: /*#__PURE__*/ l.string({ format: 'did' }),
    appeal: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<AppealView>((() => appealView) as any),
    ),
    cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    isRead: /*#__PURE__*/ l.boolean(),
    record: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.lexMap()),
    actions: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<ActionView>((() => actionView) as any),
      { maxLength: 100 },
    ),
    reports: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<ReportsSummary>((() => reportsSummary) as any),
    ),
    subject: /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<AdminDefs.RepoRef>(
          (() => AdminDefs.repoRef) as any,
        ),
        /*#__PURE__*/ l.typedRef<RepoStrongRef.Main>(
          (() => RepoStrongRef.main) as any,
        ),
      ],
      false,
    ),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    updatedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    enforcement: /*#__PURE__*/ l.ref<EnforcementView>(
      (() => enforcementView) as any,
    ),
    availableActions: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.string<{ knownValues: ['appeal'] }>(),
      ),
    ),
  }),
)

export { subjectViewDetail }

/** Push notification preferences by moderation notification category. These preferences do not hide in-app inbox activity. Each category defaults to enabled. */
type NotificationPreferences = {
  $type?: 'tools.ozone.inbox.defs#notificationPreferences'

  /**
   * Notify when labels are applied to or removed from the account or its content (labelApplied and labelRemoved actions).
   */
  labels: boolean

  /**
   * Notify about moderation actions against the account or its content, action reversals, appeal outcomes, and standing changes. Label application and removal are controlled by labels.
   */
  account: boolean

  /**
   * Notify about outcomes of reports filed by the account (reportResolved and reportReopened).
   */
  reports: boolean
}

export type { NotificationPreferences }

/** Push notification preferences by moderation notification category. These preferences do not hide in-app inbox activity. Each category defaults to enabled. */
const notificationPreferences =
  /*#__PURE__*/ l.typedObject<NotificationPreferences>(
    $nsid,
    'notificationPreferences',
    /*#__PURE__*/ l.object({
      labels: /*#__PURE__*/ l.boolean(),
      account: /*#__PURE__*/ l.boolean(),
      reports: /*#__PURE__*/ l.boolean(),
    }),
  )

export { notificationPreferences }
